module.exports = __webpack_public_path__ + "img/logo_ytz.725c0460.png";